import React, { memo } from 'react';
import { ISwitchAgentAccordionItem } from '..';
import { ExpandableContainer } from './ExpandableContainer';
import { ThinkAccordionItemRenderer } from './ThinkAccordionItemRenderer';
import { MainContentCmp } from '@/pages/aigc/pages/Agent/ChatPage/components/SubComp';

export interface IAccordionItemContentProps {
  /** 子项列表 */
  items: ISwitchAgentAccordionItem[];
  /** 是否展开 */
  isOpen: boolean;
  /** 流式输出状态 */
  streamingState?: string;
  /** 是否手动打开 */
  isManualOpen?: boolean;
  /** 思考ID */
  thinkId: string;
  /** 是否已完成 */
  isDone: boolean;
  /** 添加到手动列表的方法 */
  addToManualList: (id: string) => void;
  /** 消息 ID */
  messageId?: string;
}

// 列表滚动容器：优先 content（agent 数据层预构建），否则走统一渲染器（tool）
export const AccordionItemContent = memo(
  ({
    items,
    streamingState,
    messageId,
    thinkId,
    ...restProps
  }: IAccordionItemContentProps) => (
    <div className={'dba-switch-agent-accordion-content-items'}>
      <ExpandableContainer
        maxHeight={215}
        thinkId={thinkId || ''}
        {...restProps}
      >
        {items?.map((item, idx) => {
          if (item.content) {
            return (
              <React.Fragment key={`${idx}`}>{item.content}</React.Fragment>
            );
          }
          if (item.value) {
            return (
              <span
                key={`${idx}`}
                className="dba-system-message-input dba-system-message-input-tool-use"
              >
                <MainContentCmp
                  value={item.value}
                  streamingState={streamingState}
                  from="think"
                  messageId={messageId}
                />
              </span>
            );
          }
          return (
            <ThinkAccordionItemRenderer
              key={`${item.thinkId || thinkId}-${item.type}-${idx}`}
              item={item}
              streamingState={streamingState}
              messageId={messageId}
            />
          );
        })}
      </ExpandableContainer>
    </div>
  ),
);
AccordionItemContent.displayName = 'AccordionItemContent';
